import { Reveal } from "./Reveal";

export const Founder = () => (
  <section
    id="founder"
    data-testid="founder-section"
    className="border-t border-ink/5 bg-cream"
  >
    <div className="mx-auto grid max-w-[1240px] items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[420px_1fr] lg:gap-20 lg:px-8 lg:py-32">
      <Reveal y={32}>
        <div
          data-testid="founder-photo"
          className="relative aspect-[4/5] overflow-hidden rounded-[20px] border border-ink/10 bg-sage shadow-[0_20px_60px_rgba(23,33,29,0.12)]"
        >
          <img
            src="/assets/headshot.png"
            alt="Zachary Williams, Founder of Build.Make.Win"
            className="h-full w-full object-cover"
          />
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-growth sm:text-sm">
          Founder
        </p>
        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
          Zachary Williams
        </h2>
        <p className="mt-2 font-display text-lg font-medium text-evergreen">
          Founder, Build.Make.Win
        </p>
        <div className="mt-7 space-y-5 font-body text-lg leading-relaxed text-slate">
          <p>
            Zachary Williams is a builder and operator with experience across business,
            technology, operations, and product development. Build.Make.Win grew from a habit of
            seeing frustrating, everyday problems and asking why there was not a better way to
            solve them.
          </p>
          <p>
            CoachER started the same way. While coaching youth baseball and softball, Zachary
            found himself managing practice plans, player notes, schedules, lineups, and
            communication across too many disconnected tools. He decided to build the tool he
            wanted in the dugout.
          </p>
          <p>
            Build.Make.Win exists to keep doing that: find real problems, build focused solutions,
            and create products worth growing.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
